import { render, staticRenderFns } from "./taskFilter.vue?vue&type=template&id=554b1ab0&scoped=true&"
import script from "./taskFilter.vue?vue&type=script&lang=js&"
export * from "./taskFilter.vue?vue&type=script&lang=js&"
import style0 from "./taskFilter.vue?vue&type=style&index=0&id=554b1ab0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554b1ab0",
  null
  
)

export default component.exports